const compareArrays = (tableCols: any, tableColumns: any) => {
  let response = true;

  if (!tableCols || !tableColumns) response = undefined;
  if (tableCols.length !== tableColumns.length) response = false;
  for (let i = tableCols.length; i >= 0; i -= 1) {
    if (tableCols[i] !== tableColumns[i]) response = false;
  }
  return response;
};

export default compareArrays;
